import script from "./buttonGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./buttonGroup.vue?vue&type=script&setup=true&lang=js"

import "./buttonGroup.vue?vue&type=style&index=0&id=dfac30d4&lang=scss&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfac30d4"]])

export default __exports__